import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Plus, Flame, Beef, Wheat, Droplet } from 'lucide-react';

export function ManualEntryModal({
  isOpen,
  onClose,
  onAddFood,
}) {
  const [formData, setFormData] = useState({
    name: '',
    calories: '',
    protein: '',
    carbs: '',
    fat: '',
    grams: '100',
  });

  const handleSubmit = () => {
    if (!formData.name.trim()) return;
    
    onAddFood({
      name: formData.name.trim(),
      calories: Number(formData.calories) || 0,
      protein: Number(formData.protein) || 0,
      carbs: Number(formData.carbs) || 0,
      fat: Number(formData.fat) || 0,
      grams: Number(formData.grams) || 100,
      isManual: true,
    });
    
    // Reset form
    setFormData({
      name: '',
      calories: '',
      protein: '',
      carbs: '',
      fat: '',
      grams: '100',
    });
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-900 border-slate-800 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <Plus className="h-5 w-5 text-green-400" />
            Add Food Manually
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {/* Name */}
          <div className="space-y-2">
            <Label className="text-white">Food Name</Label>
            <Input
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="e.g., Grilled Chicken Breast"
              className="bg-slate-800 border-slate-700 text-white"
              autoFocus
            />
          </div>

          {/* Serving Size */}
          <div className="space-y-2">
            <Label className="text-white">Serving Size (g)</Label>
            <Input
              type="number"
              value={formData.grams}
              onChange={(e) => setFormData({ ...formData, grams: e.target.value })}
              placeholder="100"
              className="bg-slate-800 border-slate-700 text-white"
            />
          </div>

          {/* Calories */}
          <div className="space-y-2">
            <Label className="text-white flex items-center gap-2">
              <Flame className="h-4 w-4 text-orange-400" />
              Calories
            </Label>
            <Input
              type="number"
              value={formData.calories}
              onChange={(e) => setFormData({ ...formData, calories: e.target.value })}
              placeholder="0"
              className="bg-slate-800 border-slate-700 text-white"
            />
          </div>

          {/* Macros Grid */}
          <div className="grid grid-cols-3 gap-3">
            <div className="space-y-2">
              <Label className="text-white flex items-center gap-1 text-sm">
                <Beef className="h-3 w-3 text-red-400" />
                Protein (g)
              </Label>
              <Input
                type="number"
                value={formData.protein}
                onChange={(e) => setFormData({ ...formData, protein: e.target.value })}
                placeholder="0"
                className="bg-slate-800 border-slate-700 text-white"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-white flex items-center gap-1 text-sm">
                <Wheat className="h-3 w-3 text-yellow-400" />
                Carbs (g)
              </Label>
              <Input
                type="number"
                value={formData.carbs}
                onChange={(e) => setFormData({ ...formData, carbs: e.target.value })}
                placeholder="0"
                className="bg-slate-800 border-slate-700 text-white"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-white flex items-center gap-1 text-sm">
                <Droplet className="h-3 w-3 text-blue-400" />
                Fat (g)
              </Label>
              <Input
                type="number"
                value={formData.fat}
                onChange={(e) => setFormData({ ...formData, fat: e.target.value })}
                placeholder="0"
                className="bg-slate-800 border-slate-700 text-white"
              />
            </div>
          </div>

          {/* Submit Button */}
          <Button
            onClick={handleSubmit}
            disabled={!formData.name.trim()}
            className="w-full bg-green-600 hover:bg-green-500"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add to Today
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ManualEntryModal;
